import React, { useEffect, useRef } from 'react';
import { HiOutlineX } from 'react-icons/hi';
import DefaultAvatar from './DefaultAvatar';

/**
 * 프로필 아바타와 문구를 브라우저 너비 25% 모달 안에 표시한다.
 */
const AvatarPreviewModal = ({ open, imageUrl, message, alt = '프로필 사진', onClose }) => {
  const onCloseRef = useRef(onClose);
  onCloseRef.current = onClose;

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') onCloseRef.current();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  if (!open) return null;

  const trimmedMessage = (message || '').trim();

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div
        className="relative flex w-[25vw] min-w-[17.5rem] max-w-[95vw] max-h-[90vh] flex-col overflow-hidden rounded-lg bg-white shadow-xl"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-label={alt}
      >
        <div className="flex shrink-0 items-center justify-between border-b border-gray-200 px-4 py-3">
          <h4 className="truncate text-base font-semibold text-gray-900">프로필 사진</h4>
          <button
            type="button"
            onClick={onClose}
            className="p-1 text-gray-500 hover:text-gray-700"
            aria-label="닫기"
          >
            <HiOutlineX className="h-5 w-5" />
          </button>
        </div>
        <div className="flex min-h-0 flex-col items-center overflow-auto px-4 py-4">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={alt}
              className={`${trimmedMessage ? 'max-h-[calc(90vh-9rem)]' : 'max-h-[calc(90vh-6rem)]'} w-full object-contain`}
            />
          ) : (
            <DefaultAvatar className="h-40 w-40" title={alt} />
          )}
          {trimmedMessage ? (
            <p className="mt-3 w-full break-words text-center text-sm text-gray-700">
              {trimmedMessage}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default AvatarPreviewModal;
